/**
 * Gives browser code a minimal `process.env` when the page has no `process` global.
 *
 * Module Federation resolves each shared library (vuetify, vue, pinia, ...) to the highest
 * version offered by the host or any remote. When a remote ships a newer copy, the host
 * executes that remote's bundle, which webpack never rewrote for the host's globals. Newer
 * Vuetify releases read `process.env.VITE_LOGGER_ENABLED` at module load, so without this
 * shim a remote's copy throws `ReferenceError: process is not defined` before the app mounts.
 *
 * Only `env` is provided. Anything else stays undefined so libraries feature-detecting Node
 * through `process.versions` or `process.release` keep taking their browser path.
 */
export function installProcessEnvShim(target: typeof globalThis = globalThis): void {
  const existing = (target as { process?: { env?: unknown } }).process;
  if (existing === undefined) {
    Object.defineProperty(target, 'process', {
      value: { env: {} },
      configurable: true,
      writable: true,
    });
  } else if (existing !== null && typeof existing === 'object' && existing.env === undefined) {
    existing.env = {};
  }
}
